import React from "react";
import FormText from "reactstrap/lib/FormText";
import Input from "reactstrap/lib/Input";
import Label from "reactstrap/lib/Label";
import { Error } from "../Error";

export interface ITimezoneSelectProps {
  onChange?: (e?: any) => any;
  isValid?: boolean;
  infoMessage?: string;
  label?: string;
  name?: string;
  value?: number;
  errorMessage?: string;
}
export const TimezoneSelect = (props: ITimezoneSelectProps) => {
  return (
    <Label className="w-100">
      {props.label ? props.label : null}
      <Input
        type="select"
        onChange={props.onChange}
        value={props.value || (-1 * new Date().getTimezoneOffset() / 60)}
        name={props.name || undefined}
        style={{ borderRadius: '0px' }}
      >
        <option value={-10}>Hawaii Standard Time (Honolulu)</option>
        <option value={-8}>Alaska Standard Time (Anchorage)</option>
        <option value={-7}>Pacific Daylight Time (Los Angeles)</option>
        <option value={-6}>Mountain Daylight Time (Phoenix)</option>
        <option value={-5}>Central Daylight Time (Chicago)</option>
        <option value={-4}>Eastern Daylight Time (New York)</option>
        {/* <option value={5}>Indian Standard Time (Mumbai)</option> */}
      </Input>
      {props.infoMessage ? (
        <FormText color="muted">{props.infoMessage}</FormText>
      ) : null}
      {props.isValid === false ? <Error>{props.errorMessage}</Error> : null}
    </Label>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/form/modules/input/TimezoneSelect.tsx